import React from 'react';
import { Row, Col } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import styles from './CaptionedImagesRow.module.less';

const CaptionedImagesRow = ({ ecmContent }) => {
  const { jsonObject } = ecmContent || {};
  const { title, titleStyle, titleAlign, subtitle, rows } = jsonObject || {};

  const titleClass = titleStyle === 'large' ? styles.large_title : styles.small_title;
  const alignText = titleAlign === 'left' ? styles.left_title : styles.center_title;

  return (
    <div className={`${styles.container}`}>
      <div className={`${alignText}`}>
        {title && <div className={`${titleClass}`}>{title}</div>}
        {subtitle && <div className={`${styles.subtitle}`}>{subtitle}</div>}
      </div>
      {rows?.map((row, index) => (
        <div key={index} className={`${styles.row}`}>
          {row.row_title && (
            <div
              className={`${styles.row_title}`}
              style={{ justifyContent: row.row_title_align === 'center' ? 'center' : 'left' }}
            >
              {row.row_title}
            </div>
          )}
          <Row className={`${styles.image_container}`}>
            {row.images?.map((image, index) => (
              <Col key={index} className={`${styles.col}`}>
                {image.image_url && (
                  <img src={image.image_url} alt="" className={`${styles.image}`} />
                )}
                {image.sub_header && (
                  <div className={`${styles.subheader}`}>{image.sub_header}</div>
                )}
                {image.sub_text && <div className={`${styles.subtext}`}>{image.sub_text}</div>}
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </div>
  );
};

CaptionedImagesRow.propTypes = {
  ecmContent: PropTypes.object
};
CaptionedImagesRow.defaultProps = {
  ecmContent: {
    content: { jsonObject: { title: '', images: [] } }
  }
};

export default CaptionedImagesRow;
